import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})

export class UploadService {

    controller = 'Upload';
    constructor(private base: BaseService) {}

    upload(file):Observable<any> {
        const fromData = new FormData();
        fromData.append("file", file, file.name);
        return this.base.save(this.controller + '/RegisterImage', fromData)
    }
}